function cartDrawerSuppressedOnCartTemplate() {
  try {
    return document.body.classList.contains('template-cart');
  } catch {
    return false;
  }
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  connectedCallback() {
    if (!this._backdropCloseBound) {
      this._backdropCloseBound = true;
      this.addEventListener('click', (event) => {
        if (!event.target.closest('#CartDrawer-Overlay')) return;
        this.close();
      });
    }
    if (cartDrawerSuppressedOnCartTemplate()) {
      this.close();
    }
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    if (cartLink.dataset.cartDrawerKeydownBound) return;
    cartLink.dataset.cartDrawerKeydownBound = 'true';
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        if (cartDrawerSuppressedOnCartTemplate()) return;
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (cartDrawerSuppressedOnCartTemplate()) return;
    if (typeof window.__suppressDuplicateCartUi === 'function') {
      window.__suppressDuplicateCartUi();
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.dispatchEvent(new CustomEvent('cart-drawer:triggered', { bubbles: true }));

    requestAnimationFrame(() => {
      this.classList.add('animate', 'active');
      if (typeof window.syncCartDrawerArtworkBwThumbs === 'function') {
        window.syncCartDrawerArtworkBwThumbs();
      }
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (typeof window.__suppressDuplicateCartUi === 'function') {
      window.__suppressDuplicateCartUi();
    }
    if (!cartDrawerSuppressedOnCartTemplate()) this.open();
    requestAnimationFrame(() => {
      if (typeof window.syncCartDrawerArtworkBwThumbs === 'function') {
        window.syncCartDrawerArtworkBwThumbs();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

(function bindCartIconToDrawer() {
  if (window.__cartDrawerIconClickBound) return;
  window.__cartDrawerIconClickBound = true;

  document.addEventListener(
    'click',
    (event) => {
      const cartLink = event.target.closest('#cart-icon-bubble');
      if (!cartLink) return;
      if (event.defaultPrevented) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (typeof event.button === 'number' && event.button !== 0) return;

      if (typeof window.__suppressDuplicateCartUi === 'function') {
        window.__suppressDuplicateCartUi();
      }

      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      if (cartDrawerSuppressedOnCartTemplate()) return;

      event.preventDefault();
      drawer.open(cartLink);
    },
    true
  );
})();

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
